/** Cede el hilo para que React pinte antes de trabajo largo (await). */
export function yieldToUi() {
  return new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(() => resolve()));
  });
}
